<template>
  <div class="box">
    <div class="box-header">
      <h4 class="box-title"><i class="icofont-listine-dots"></i> Resultado</h4>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <th>Duplicados</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Município</td>
            <td class="text-center font-weight-bold">
              <loader :value="municipio" :loading="loading"></loader>
            </td>
          </tr>
          <tr>
            <td>Equipe</td>
            <td class="text-center font-weight-bold">
              <loader :value="equipe" :loading="loading"></loader>
            </td>
          </tr>
        </tbody>
      </table>
      <FonteEsusPecGlobal texto="Cadastros registrados até" />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  components: {
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    municipio: {
      type: [String, Number],
      default: '',
    },
    equipe: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>

<style></style>
